import { useState } from 'react';
import { CircularProgress } from '@mui/material';
import ImageSelectionItem from './ImageSelectionItem';

interface Props {
  images: {
    id: number;
    url: string;
    thumbnail: string;
  }[],
  isLoading: boolean;
  handleSelected: (id: number, url: string, thumbnail: string) => void
}

const Index = (props: Props) => {
  const { images, handleSelected, isLoading } = props;
  const [currentId, setCurrentId] = useState(0);

  const handleClick = (id: number, url: string, thumbnail: string) => {
    setCurrentId(id);
    handleSelected(id, url, thumbnail);
  };

  return ((
    <div className="image-imagelist h-75">
      {isLoading ? (
        <div style={{
          width: '100%',
          minHeight: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        >
          <CircularProgress size={50} />
        </div>
      ) : (
        <ul className="imageList">
          {images.map((item) => (
            <ImageSelectionItem
              key={item.id}
              isActive={currentId === item.id}
              id={item.id}
              url={item.url}
              thumbnail={item.thumbnail}
              handleClick={handleClick}
            />
          ))}
        </ul>
      )}
    </div>
  ));
};

export default Index;
